import { chakra, useBreakpointValue } from '@chakra-ui/react'
import { Visibility } from '../../../Data/Types'
interface VisibilityResultProps {
	visibility: Visibility
}

const arrowTransition = 'all 0.5s ease-in-out'
const VisibilityResults: React.FC<VisibilityResultProps> = ({ visibility }) => {
	const scale = useBreakpointValue({ base: 1, md: 2 })

	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			width={115.0 * (scale || 2)}
			height={90.498 * (scale || 2)}
			viewBox="0 0 115.09 90.498"
		>
			<defs>
				<clipPath id="clippath">
					<path
						d="M104.77 60.64c0 12.26-4.68 23.41-12.32 31.79l-5.84-5.84c6.17-6.89 9.92-15.98 9.92-25.95 0-1.03-.04-2.05-.12-3.06-.8-10.29-5.6-19.46-12.85-25.95-6.89-6.17-15.99-9.92-25.96-9.92s-19.07 3.75-25.96 9.92c-7.25 6.49-12.05 15.66-12.85 25.95a38.74 38.74 0 0 0-.12 3.06c0 9.97 3.75 19.06 9.92 25.95l-5.84 5.84C15.1 84.05 10.43 72.9 10.43 60.64c0-1.03.03-2.05.1-3.06.8-12.57 6.53-23.8 15.28-31.78 8.38-7.66 19.54-12.33 31.79-12.33s23.41 4.67 31.79 12.33c8.75 7.98 14.48 19.21 15.28 31.78.07 1.01.1 2.03.1 3.06Z"
						style={{
							fill: 'none',
						}}
					/>
				</clipPath>
				<style>
					{
						'.cls-1{fill:#fbb541}.cls-6{fill:#404041;font-family:Sansation-Regular,Sansation;font-size:6px}.cls-7{fill:#e2dfe2}.cls-9{fill:#ffe080}.cls-10{fill:#fcb743}.cls-12{fill:#fdc55c}.cls-13{fill:#ec1c24}.cls-14{fill:#edebee}.cls-18{fill:#fdc45a}'
					}
				</style>
			</defs>
			<g id="bg">
				<path
					className="cls-9"
					d="M58.48 37.88c5.99.6 10.67 3.39 13.74 8.59 4.8 8.12 2.35 18.31-5.55 23.5-.87.57-1.82 1.09-1.91 2.31-.2 1.29-.05 2.59-.09 3.88-.03 1.1-.12 1.25-1.24 1.26-1.04 0-2.09.18-3.11-.18-.45-.32-.41-.82-.41-1.28-.02-1.95 0-3.89 0-5.84 0-.91.32-1.69.88-2.38.58-.7 1.07-1.45 1.34-2.33.36-1.02.12-2.08.19-3.11.09-1.35-.25-2.74.41-4.05.21-.42-.14-.74-.36-1.06-.72-1.21-1.2-.06-1.78.19-2.26.17-4.51.17-6.76.01-.17-.05-.33-.12-.43-.27-.49-.71-.93-.57-1.36.06-.4.44-.56.91-.23 1.47.31.52.25 1.11.27 1.69.06 1.65-.14 3.31.12 4.96.23.97.79 1.75 1.41 2.51.9 1.09 1.07 2.3.63 3.62-.21.17-.42.07-.59-.06-3.69-2.58-7.03-5.49-8.48-9.95-2.21-6.81-1.11-12.94 3.83-18.28 2.6-2.8 5.78-4.48 9.49-5.25Z"
				/>
				<path
					className="cls-18"
					d="M58.48 37.88c-.12.61-.7.46-1.05.55-6.8 1.78-11.79 7.28-12.83 14.21-.79 5.29.55 9.96 4 14.05 1.09 1.29 2.33 2.35 3.73 3.23.68.43 1.15 1.09 1.82 1.52.41.41.32.93.33 1.43.03.97-.03 1.95.03 2.92.02.24.03.55.37.57.33.01.37-.28.41-.53.05-.29.04-.58.04-.86 0-1.59-.01-3.17 0-4.76 0-.49-.09-1.03.38-1.4.43.15.47.54.48.89.06 2.24.07 4.48 0 6.71 0 .25-.08.5-.24.71-.33.28-.72.3-1.12.31-1.3.02-2.6.04-3.89 0-1.12-.03-1.2-.16-1.24-1.26-.04-1.29.12-2.59-.09-3.88-.08-1.02-.78-1.58-1.55-2.07-4.44-2.82-7.21-6.8-8.09-11.99-1.68-9.83 5.18-18.8 14.63-20.19 1.29-.19 2.58-.22 3.88-.15Z"
				/>
				<path
					className="cls-7"
					d="M65.43 84.02c-.15 1-.8 1.34-1.74 1.3-.4.41-.93.35-1.42.35-3.39.01-6.77.01-10.16 0-.5 0-1.02.06-1.42-.35-.93.04-1.58-.3-1.74-1.3-.17-.26-.07-.56-.1-.84-.08-.69.22-.83.81-.58.55.23 1.13.22 1.7.22h11.66c.47 0 .94 0 1.4-.11q1.16-.29 1.12.91c0 .15-.02.29-.1.41ZM49.6 80.99c-.99-.67-.55-1.71-.65-2.6 5.49.51 10.99.51 16.48 0-.1.9.34 1.93-.65 2.6-.38.47-.91.55-1.46.56-4.08.02-8.17.02-12.25 0-.55 0-1.09-.08-1.46-.56Z"
				/>
				<path
					d="M65.42 78.38c-.55.54-1.19.67-1.96.67-4.19-.03-8.38-.03-12.56 0-.77 0-1.41-.13-1.96-.67 1.12-1.94.48-4.07.67-6.1.39 1.26.13 2.56.16 3.83.01.71.15 1.01.94.98 1.72-.07 3.44-.04 5.16-.05.82-.48 1.71-.23 2.57-.27.6.02 1.22-.13 1.76.26 1.22.01 2.44 0 3.66.05.6.02.7-.24.72-.76.07-1.35-.23-2.71.18-4.04 0 .83.05 1.66 0 2.48-.06 1.26 0 2.5.66 3.62Z"
					style={{
						fill: '#eeebed',
					}}
				/>
				<path
					className="cls-14"
					d="M49.6 80.99c.55.16 1.12.23 1.7.22 3.93-.01 7.85-.01 11.78 0 .58 0 1.14-.06 1.7-.22.28.82 1.14 1.43.87 2.46-.05.21-.02.43-.22.58v-1.46c-.71.61-1.43.6-2.17.6-4.15-.02-8.31-.01-12.47 0-.62 0-1.22.02-1.85-.8v1.67c-.42-.82-.32-1.59.25-2.3.18-.22.41-.42.4-.74Z"
				/>
				<path
					d="M64.34 86.41v1.07c0 1.34-.59 1.93-1.94 1.96h-.11c-1.04-.17-1.77.1-1.81 1.31-.39-.87-1.09-1.08-1.98-1-.6.05-1.2.02-1.81 0-.97-.06-1.98.27-2.9-.29-.57 0-1.14-.02-1.71-.03-1.49-.02-2.05-.58-2.05-2.07v-.96c1.46.7 3.02.53 4.55.53 1.99 0 3.97-.02 5.96 0 1.3.02 2.58.03 3.79-.54Z"
					style={{
						fill: '#e1dfe1',
					}}
				/>
				<path
					className="cls-14"
					d="M64.34 86.41c-.45.65-1.05.88-1.84.88-3.54-.03-7.08-.03-10.62 0-.8 0-1.4-.23-1.84-.88.22-.36.43-.73.65-1.09H63.7l.65 1.09Z"
				/>
				<path
					d="M53.79 89.47h2.96c.31.29.36.69.45 1.07.17.68.46 1.27.97 1.76.21.2.59.38.3.78-2.63.88-4.6-.64-4.68-3.61Z"
					style={{
						fill: '#7061aa',
					}}
				/>
				<path
					d="M58.47 93.07c-1-1-1.74-2.13-1.72-3.61.79 0 1.59.05 2.38-.04 1.07-.12 1.57.21 1.36 1.33-.33 1.07-.95 1.88-2.01 2.32Z"
					style={{
						fill: '#847ab8',
					}}
				/>
				<path
					className="cls-12"
					d="M34.42 47.81c.79.31 1.77.66 2.72 1.08.39.17.57.54.39.99-.17.42-.51.66-.94.51-.98-.33-1.96-.7-2.91-1.11-.42-.18-.46-.62-.32-1.03.14-.41.49-.49 1.07-.44ZM81.07 48.45c0 .56-.23.8-.59.94-.84.32-1.67.65-2.51.95-.51.18-.93.03-1.13-.5-.19-.51.08-.85.51-1.03.86-.35 1.73-.71 2.62-.98.6-.18 1.07.02 1.11.61ZM34.36 61.94c-.64 0-.95-.15-1.03-.57-.08-.38-.02-.77.36-.93.96-.4 1.93-.77 2.91-1.1.43-.14.76.1.94.52.17.4.03.77-.31.93-1.01.45-2.05.83-2.87 1.16ZM79.95 61.91c-.81-.32-1.79-.67-2.74-1.09-.39-.17-.55-.55-.36-.99.18-.43.53-.63.95-.49.95.32 1.88.69 2.81 1.06.44.18.53.57.43.99-.12.48-.49.57-1.09.53Z"
				/>
				<path
					className="cls-18"
					d="M34.21 55.65c-.5 0-1.01.02-1.51 0-.48-.02-.7-.33-.7-.79s.24-.76.72-.77c1.01-.02 2.02-.02 3.02 0 .48.01.72.36.72.79 0 .43-.26.76-.74.77-.5.02-1.01 0-1.51 0ZM80.1 55.64c-.5 0-1.01.03-1.51 0-.48-.03-.69-.38-.67-.82.02-.39.24-.71.66-.72 1.04-.02 2.09-.03 3.13 0 .48.01.68.36.66.82-.02.42-.23.7-.65.72-.54.03-1.08 0-1.62 0Z"
				/>
				<path
					className="cls-1"
					d="M60.2 77.03h-1.69c-.39-.37-.35-.86-.35-1.32-.01-1.8 0-3.61 0-5.42 0-1.27.31-2.44 1.17-3.4.94-1.06 1.32-2.28 1.23-3.69-.07-1.04-.03-2.09 0-3.14 0-.46-.03-.95.37-1.31 1.33-.35 1.6-.19 1.57 1.08-.04 1.85.13 3.7-.09 5.55-.08 1.03-.72 1.77-1.34 2.51-.56.66-.86 1.36-.85 2.25.03 2.3 0 4.59 0 6.89ZM55.68 68.84c0 2.37-.02 4.75 0 7.12 0 .59-.09.94-.81.93-.7-.01-.72-.4-.72-.91.01-1.51 0-3.02 0-4.53.18-1.57-.1-2.97-1.28-4.15-.5-.49-.88-1.14-.89-1.91-.22-2.03-.1-4.06-.07-6.08.02-.99.83-.72 1.46-.6.48.3.43.79.44 1.25.03 1.15.05 2.3 0 3.45-.06 1.29.3 2.38 1.14 3.37.48.56 1.17 1.14.73 2.07Z"
				/>
				<path
					className="cls-18"
					d="M53.52 58.88q-1.53 0-1.54 1.57v4.94c-.44-1.04-.13-2.12-.19-3.18-.05-.83 0-1.66-.01-2.48 0-.28.08-.62-.15-.83-.9-.85-.45-1.44.34-1.98.55-.1 1.08-.15 1.56.23h7.33c.48-.38 1.01-.33 1.56-.23.79.54 1.24 1.13.34 1.98-.25.24-.14.62-.15.94v4.54c0 .35.11.73-.2 1.02v-4.94q0-1.57-1.54-1.57c-1.02.5-6.31.5-7.33 0Z"
				/>
				<path
					d="M63.53 42.62c1.05.24 1.94 1 2.82 1.72 2.16 1.78 3.68 4.01 4.53 6.7.2.64.22 1.19-.48 1.42-.69.22-.91-.34-1.09-.88-1.05-3.12-2.96-5.55-5.87-7.17-.22-.12-.45-.25-.62-.42-.3-.28-.28-.65-.13-1 .13-.31.42-.37.85-.36Z"
					style={{
						fill: '#ffe9c7',
					}}
				/>
				<path
					className="cls-10"
					d="M53.52 57.14c-.52-.08-1.09.21-1.56-.23.08-.56.46-.68.94-.63.51.06.61.43.62.86ZM62.41 56.91c-.47.44-1.04.15-1.56.23 0-.43.11-.8.62-.86.48-.06.86.07.94.63Z"
				/>
				<path
					className="cls-9"
					d="M53.52 58.88h7.33c0 1.37-.08 2.75.03 4.11.14 1.69-.29 3.13-1.46 4.34-.7.73-.92 1.62-.92 2.57-.02 2.38 0 4.76.01 7.13h-2.64c0-2.43.01-4.86.01-7.29 0-.31.07-.65-.2-.91-.03-.82-.54-1.41-1.04-1.96-.83-.9-1.2-1.9-1.15-3.14.07-1.62.02-3.24.03-4.86Z"
				/>
				<g
					style={{
						clipPath: 'url(#clippath)',
					}}
				>
					<path
						style={{
							fill: '#f6921e',
						}}
						d="M98.33 16.87 57.62 57.58h-.01v.01l29.01 29L98.33 98.3l16.86-40.72-16.86-40.71z"
					/>
					<path
						style={{
							fill: '#f6921e',
							opacity: 0.6,
						}}
						d="M57.61 0 16.88 16.87 57.6 57.58h.02l40.71-40.71L57.61 0z"
					/>
					<path
						style={{
							opacity: 0.05,
							fill: '#f6921e',
						}}
						d="M57.6 57.58 16.88 16.87.02 57.58 16.88 98.3l5.87-5.87 5.85-5.84 29.01-29v-.01h-.01z"
					/>
				</g>
				<text className="cls-6" transform="rotate(-107.21 37.448 30.326)">
					<tspan x={0} y={0}>
						{'N'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-100.61 38.482 27.823)">
					<tspan x={0} y={0}>
						{'O'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-94.84 39.036 25.05)">
					<tspan x={0} y={0}>
						{'T'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-91.51 39.07 22.998)">
					<tspan x={0} y={0} />
				</text>
				<text className="cls-6" transform="rotate(-87.54 40.495 21.757)">
					<tspan x={0} y={0}>
						{'V'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-83.41 40.625 18.847)">
					<tspan x={0} y={0}>
						{'I'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-79.65 41.923 17.272)">
					<tspan x={0} y={0}>
						{'S'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-75.85 42.26 14.272)">
					<tspan x={0} y={0}>
						{'I'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-71.94 43.78 12.357)">
					<tspan x={0} y={0}>
						{'B'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-66.86 45.058 8.364)">
					<tspan x={0} y={0}>
						{'L'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-62.05 46.624 4.337)">
					<tspan x={0} y={0}>
						{'E'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-11.19 133.725 -232.026)">
					<tspan x={0} y={0}>
						{'V'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-7.02 195.102 -411.464)">
					<tspan x={0} y={0}>
						{'I'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(-3.24 389.467 -933.454)">
					<tspan x={0} y={0}>
						{'S'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(.5 -2302.228 6553.306)">
					<tspan x={0} y={0}>
						{'I'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(4.29 -241.895 794.171)">
					<tspan x={0} y={0}>
						{'B'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(9.32 -95.153 393.929)">
					<tspan x={0} y={0}>
						{'L'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(14.18 -52.077 275.124)">
					<tspan x={0} y={0}>
						{'E'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(75.81 16.728 86.41)">
					<tspan x={0} y={0}>
						{'B'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(81.19 17.909 83.165)">
					<tspan x={0} y={0}>
						{'R'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(84.95 18.127 81.676)">
					<tspan x={0} y={0}>
						{'I'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(88.92 19.447 79.003)">
					<tspan x={0} y={0}>
						{'G'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(94.8 20.565 76.151)">
					<tspan x={0} y={0}>
						{'H'}
					</tspan>
				</text>
				<text className="cls-6" transform="rotate(100.32 21.155 74.022)">
					<tspan x={0} y={0}>
						{'T'}
					</tspan>
				</text>
			</g>
			<chakra.path
				id="bright"
				transition={arrowTransition}
				opacity={visibility === 'bright' ? 1 : 0}
				className="cls-13"
				transform="translate(0 -2.83)"
				d="m102.95 58.88 12.14 7.01V51.87z"
			/>
			<chakra.path
				transition={arrowTransition}
				opacity={visibility === 'visible' ? 1 : 0}
				id="dimmed"
				className="cls-13"
				transform="translate(0 -2.83)"
				d="m57.6 14.97 7.01-12.14H50.59z"
			/>
			<chakra.path
				transition={arrowTransition}
				id="not visible"
				opacity={visibility === 'not visible' ? 1 : 0}
				className="cls-13"
				transform="translate(0 -2.83)"
				d="M12.14 58.88 0 51.87v14.02z"
			/>
		</svg>
	)
}

// return (
// <svg
// 	id="Layer_1"
// 	width={115.0 * (scale || 2)}
// 	height={90.498 * (scale || 2)}
// 	viewBox="0 0 115.09 90.498"
// 	xmlns="http://www.w3.org/2000/svg"
// >
// 	<defs id="defs219">
// 		<clipPath id="clippath">
// 			<path
// 				d="M104.77 60.64c0 12.26-4.68 23.41-12.32 31.79l-5.84-5.84c6.17-6.89 9.92-15.98 9.92-25.95 0-1.03-.04-2.05-.12-3.06-.8-10.29-5.6-19.46-12.85-25.95a38.787 38.787 0 0 0-25.96-9.92c-9.97 0-19.07 3.75-25.96 9.92-7.25 6.49-12.05 15.66-12.85 25.95a38.74 38.74 0 0 0-.12 3.06c0 9.97 3.75 19.06 9.92 25.95l-5.84 5.84C15.1 84.05 10.43 72.9 10.43 60.64c0-1.03.03-2.05.1-3.06.8-12.57 6.53-23.8 15.28-31.78 8.38-7.66 19.54-12.33 31.79-12.33s23.41 4.67 31.79 12.33c8.75 7.98 14.48 19.21 15.28 31.78.07 1.01.1 2.03.1 3.06z"
// 				id="path216"
// 				style={{
// 					fill: 'none',
// 				}}
// 			/>
// 		</clipPath>
// 		<style id="style214">
// 			{
// 				'.cls-1{fill:#fbb541}.cls-6{fill:#404041;font-family:Sansation-Regular,Sansation;font-size:6px}.cls-7{fill:#e2dfe2}.cls-9{fill:#ffe080}.cls-10{fill:#fcb743}.cls-12{fill:#fdc55c}.cls-13{fill:#ec1c24}.cls-14{fill:#edebee}.cls-18{fill:#fdc45a}'
// 			}
// 		</style>
// 	</defs>
// 	<g id="bg" transform="translate(0 -2.83)">
// 		<g id="g267">
// 			<path
// 				className="cls-9"
// 				d="M58.48 37.88c5.99.6 10.67 3.39 13.74 8.59 4.8 8.12 2.35 18.31-5.55 23.5-.87.57-1.82 1.09-1.91 2.31-.2 1.29-.05 2.59-.09 3.88-.03 1.1-.12 1.25-1.24 1.26-1.04 0-2.09.18-3.11-.18-.45-.32-.41-.82-.41-1.28-.02-1.95 0-3.89 0-5.84 0-.91.32-1.69.88-2.38.58-.7 1.07-1.45 1.34-2.33.36-1.02.12-2.08.19-3.11.09-1.35-.25-2.74.41-4.05.21-.42-.14-.74-.36-1.06-.72-1.21-1.2-.06-1.78.19-2.26.17-4.51.17-6.76.01-.17-.05-.33-.12-.43-.27-.49-.71-.93-.57-1.36.06-.4.44-.56.91-.23 1.47.31.52.25 1.11.27 1.69.06 1.65-.14 3.31.12 4.96.23.97.79 1.75 1.41 2.51.9 1.09 1.07 2.3.63 3.62-.21.17-.42.07-.59-.06-3.69-2.58-7.03-5.49-8.48-9.95-2.21-6.81-1.11-12.94 3.83-18.28 2.6-2.8 5.78-4.48 9.49-5.25z"
// 				id="path221"
// 			/>
// 			<path
// 				className="cls-18"
// 				d="M58.48 37.88c-.12.61-.7.46-1.05.55-6.8 1.78-11.79 7.28-12.83 14.21-.79 5.29.55 9.96 4 14.05 1.09 1.29 2.33 2.35 3.73 3.23.68.43 1.15 1.09 1.82 1.52.41.41.32.93.33 1.43.03.97-.03 1.95.03 2.92.02.24.03.55.37.57.33.01.37-.28.41-.53.05-.29.04-.58.04-.86 0-1.59-.01-3.17 0-4.76 0-.49-.09-1.03.38-1.4.43.15.47.54.48.89.06 2.24.07 4.48 0 6.71 0 .25-.08.5-.24.71-.33.28-.72.3-1.12.31-1.3.02-2.6.04-3.89 0-1.12-.03-1.2-.16-1.24-1.26-.04-1.29.12-2.59-.09-3.88-.08-1.02-.78-1.58-1.55-2.07-4.44-2.82-7.21-6.8-8.09-11.99-1.68-9.83 5.18-18.8 14.63-20.19 1.29-.19 2.58-.22 3.88-.15z"
// 				id="path223"
// 			/>
// 			<path
// 				className="cls-7"
// 				d="M65.43 84.02c-.15 1-.8 1.34-1.74 1.3-.4.41-.93.35-1.42.35-3.39.01-6.77.01-10.16 0-.5 0-1.02.06-1.42-.35-.93.04-1.58-.3-1.74-1.3-.17-.26-.07-.56-.1-.84-.08-.69.22-.83.81-.58.55.23 1.13.22 1.7.22h11.66c.47 0 .94 0 1.4-.11q1.16-.29 1.12.91c0 .15-.02.29-.1.41z"
// 				id="path225"
// 			/>
// 			<path
// 				className="cls-7"
// 				d="M49.6 80.99c-.99-.67-.55-1.71-.65-2.6 5.49.51 10.99.51 16.48 0-.1.9.34 1.93-.65 2.6-.38.47-.91.55-1.46.56-4.08.02-8.17.02-12.25 0-.55 0-1.09-.08-1.46-.56z"
// 				id="path227"
// 			/>
// 			<path
// 				d="M65.42 78.38c-.55.54-1.19.67-1.96.67-4.19-.03-8.38-.03-12.56 0-.77 0-1.41-.13-1.96-.67 1.12-1.94.48-4.07.67-6.1.39 1.26.13 2.56.16 3.83.01.71.15 1.01.94.98 1.72-.07 3.44-.04 5.16-.05.82-.48 1.71-.23 2.57-.27.6.02 1.22-.13 1.76.26 1.22.01 2.44 0 3.66.05.6.02.7-.24.72-.76.07-1.35-.23-2.71.18-4.04 0 .83.05 1.66 0 2.48-.06 1.26 0 2.5.66 3.62z"
// 				id="path229"
// 				style={{
// 					fill: '#eeebed',
// 				}}
// 			/>
// 			<path
// 				className="cls-14"
// 				d="M49.6 80.99c.55.16 1.12.23 1.7.22 3.93-.01 7.85-.01 11.78 0 .58 0 1.14-.06 1.7-.22.28.82 1.14 1.43.87 2.46-.05.21-.02.43-.22.58v-1.46c-.71.61-1.43.6-2.17.6-4.15-.02-8.31-.01-12.47 0-.62 0-1.22.02-1.85-.8v1.67c-.42-.82-.32-1.59.25-2.3.18-.22.41-.42.4-.74z"
// 				id="path231"
// 			/>
// 			<path
// 				d="M64.34 86.41v1.07c0 1.34-.59 1.93-1.94 1.96h-.11c-1.04-.17-1.77.1-1.81 1.31-.39-.87-1.09-1.08-1.98-1-.6.05-1.2.02-1.81 0-.97-.06-1.98.27-2.9-.29-.57 0-1.14-.02-1.71-.03-1.49-.02-2.05-.58-2.05-2.07v-.96c1.46.7 3.02.53 4.55.53 1.99 0 3.97-.02 5.96 0 1.3.02 2.58.03 3.79-.54z"
// 				id="path233"
// 				style={{
// 					fill: '#e1dfe1',
// 				}}
// 			/>
// 			<path
// 				className="cls-14"
// 				d="M64.34 86.41c-.45.65-1.05.88-1.84.88-3.54-.03-7.08-.03-10.62 0-.8 0-1.4-.23-1.84-.88.22-.36.43-.73.65-1.09H63.7l.65 1.09z"
// 				id="path235"
// 			/>
// 			<path
// 				d="M53.79 89.47h2.96c.31.29.36.69.45 1.07.17.68.46 1.27.97 1.76.21.2.59.38.3.78-2.63.88-4.6-.64-4.68-3.61z"
// 				id="path237"
// 				style={{
// 					fill: '#7061aa',
// 				}}
// 			/>
// 			<path
// 				d="M58.47 93.07c-1-1-1.74-2.13-1.72-3.61.79 0 1.59.05 2.38-.04 1.07-.12 1.57.21 1.36 1.33-.33 1.07-.95 1.88-2.01 2.32z"
// 				id="path239"
// 				style={{
// 					fill: '#847ab8',
// 				}}
// 			/>
// 			<path
// 				className="cls-12"
// 				d="M34.42 47.81c.79.31 1.77.66 2.72 1.08.39.17.57.54.39.99-.17.42-.51.66-.94.51-.98-.33-1.96-.7-2.91-1.11-.42-.18-.46-.62-.32-1.03.14-.41.49-.49 1.07-.44z"
// 				id="path241"
// 			/>
// 			<path
// 				className="cls-12"
// 				d="M81.07 48.45c0 .56-.23.8-.59.94-.84.32-1.67.65-2.51.95-.51.18-.93.03-1.13-.5-.19-.51.08-.85.51-1.03.86-.35 1.73-.71 2.62-.98.6-.18 1.07.02 1.11.61z"
// 				id="path243"
// 			/>
// 			<path
// 				className="cls-12"
// 				d="M34.36 61.94c-.64 0-.95-.15-1.03-.57-.08-.38-.02-.77.36-.93.96-.4 1.93-.77 2.91-1.1.43-.14.76.1.94.52.17.4.03.77-.31.93-1.01.45-2.05.83-2.87 1.16z"
// 				id="path245"
// 			/>
// 			<path
// 				className="cls-12"
// 				d="M79.95 61.91c-.81-.32-1.79-.67-2.74-1.09-.39-.17-.55-.55-.36-.99.18-.43.53-.63.95-.49.95.32 1.88.69 2.81 1.06.44.18.53.57.43.99-.12.48-.49.57-1.09.53z"
// 				id="path247"
// 			/>
// 			<path
// 				className="cls-18"
// 				d="M34.21 55.65c-.5 0-1.01.02-1.51 0-.48-.02-.7-.33-.7-.79s.24-.76.72-.77c1.01-.02 2.02-.02 3.02 0 .48.01.72.36.72.79 0 .43-.26.76-.74.77-.5.02-1.01 0-1.51 0z"
// 				id="path249"
// 			/>
// 			<path
// 				className="cls-18"
// 				d="M80.1 55.64c-.5 0-1.01.03-1.51 0-.48-.03-.69-.38-.67-.82.02-.39.24-.71.66-.72 1.04-.02 2.09-.03 3.13 0 .48.01.68.36.66.82-.02.42-.23.7-.65.72-.54.03-1.08 0-1.62 0z"
// 				id="path251"
// 			/>
// 			<path
// 				className="cls-1"
// 				d="M60.2 77.03h-1.69c-.39-.37-.35-.86-.35-1.32-.01-1.8 0-3.61 0-5.42 0-1.27.31-2.44 1.17-3.4.94-1.06 1.32-2.28 1.23-3.69-.07-1.04-.03-2.09 0-3.14 0-.46-.03-.95.37-1.31 1.33-.35 1.6-.19 1.57 1.08-.04 1.85.13 3.7-.09 5.55-.08 1.03-.72 1.77-1.34 2.51-.56.66-.86 1.36-.85 2.25.03 2.3 0 4.59 0 6.89z"
// 				id="path253"
// 			/>
// 			<path
// 				className="cls-1"
// 				d="M55.68 68.84c0 2.37-.02 4.75 0 7.12 0 .59-.09.94-.81.93-.7-.01-.72-.4-.72-.91.01-1.51 0-3.02 0-4.53.18-1.57-.1-2.97-1.28-4.15-.5-.49-.88-1.14-.89-1.91-.22-2.03-.1-4.06-.07-6.08.02-.99.83-.72 1.46-.6.48.3.43.79.44 1.25.03 1.15.05 2.3 0 3.45-.06 1.29.3 2.38 1.14 3.37.48.56 1.17 1.14.73 2.07z"
// 				id="path255"
// 			/>
// 			<path
// 				className="cls-18"
// 				d="M53.52 58.88q-1.53 0-1.54 1.57v4.94c-.44-1.04-.13-2.12-.19-3.18-.05-.83 0-1.66-.01-2.48 0-.28.08-.62-.15-.83-.9-.85-.45-1.44.34-1.98.55-.1 1.08-.15 1.56.23h7.33c.48-.38 1.01-.33 1.56-.23.79.54 1.24 1.13.34 1.98-.25.24-.14.62-.15.94v4.54c0 .35.11.73-.2 1.02v-4.94q0-1.57-1.54-1.57c-1.02.5-6.31.5-7.33 0z"
// 				id="path257"
// 			/>
// 			<path
// 				d="M63.53 42.62c1.05.24 1.94 1 2.82 1.72 2.16 1.78 3.68 4.01 4.53 6.7.2.64.22 1.19-.48 1.42-.69.22-.91-.34-1.09-.88-1.05-3.12-2.96-5.55-5.87-7.17-.22-.12-.45-.25-.62-.42-.3-.28-.28-.65-.13-1 .13-.31.42-.37.85-.36z"
// 				id="path259"
// 				style={{
// 					fill: '#ffe9c7',
// 				}}
// 			/>
// 			<path
// 				className="cls-10"
// 				d="M53.52 57.14c-.52-.08-1.09.21-1.56-.23.08-.56.46-.68.94-.63.51.06.61.43.62.86z"
// 				id="path261"
// 			/>
// 			<path
// 				className="cls-10"
// 				d="M62.41 56.91c-.47.44-1.04.15-1.56.23 0-.43.11-.8.62-.86.48-.06.86.07.94.63z"
// 				id="path263"
// 			/>
// 			<path
// 				className="cls-9"
// 				d="M53.52 58.88h7.33c0 1.37-.08 2.75.03 4.11.14 1.69-.29 3.13-1.46 4.34-.7.73-.92 1.62-.92 2.57-.02 2.38 0 4.76.01 7.13h-2.64c0-2.43.01-4.86.01-7.29 0-.31.07-.65-.2-.91-.03-.82-.54-1.41-1.04-1.96-.83-.9-1.2-1.9-1.15-3.14.07-1.62.02-3.24.03-4.86z"
// 				id="path265"
// 			/>
// 		</g>
// 		<g
// 			clipPath="url(#clippath)"
// 			id="g275"
// 			style={{
// 				clipPath: 'url(#clippath)',
// 			}}
// 		>
// 			<path
// 				id="polygon269"
// 				style={{
// 					fill: '#f6921e',
// 				}}
// 				d="m57.61 57.59 29.01 29L98.33 98.3l16.86-40.72-16.86-40.71-40.71 40.71h-.01z"
// 			/>
// 			<path
// 				id="polygon271"
// 				style={{
// 					fill: '#f6921e',
// 					opacity: 0.6,
// 				}}
// 				d="M57.61 57.58h.01l40.71-40.71L57.61 0 16.88 16.87 57.6 57.58z"
// 			/>
// 			<path
// 				id="polygon273"
// 				style={{
// 					opacity: 0.05,
// 					fill: '#f6921e',
// 				}}
// 				d="m16.88 98.3 5.87-5.87 5.85-5.84 29.01-29v-.01h-.01L16.88 16.87.02 57.58z"
// 			/>
// 		</g>
// 		<g id="g369">
// 			<text
// 				className="cls-6"
// 				transform="rotate(-107.21 37.448 30.326)"
// 				id="text279"
// 			>
// 				<tspan x={0} y={0} id="tspan277">
// 					{'N'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-100.61 38.482 27.823)"
// 				id="text283"
// 			>
// 				<tspan x={0} y={0} id="tspan281">
// 					{'O'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-94.84 39.036 25.05)"
// 				id="text287"
// 			>
// 				<tspan x={0} y={0} id="tspan285">
// 					{'T'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-91.51 39.07 22.998)"
// 				id="text291"
// 			/>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-87.54 40.495 21.757)"
// 				id="text295"
// 			>
// 				<tspan x={0} y={0} id="tspan293">
// 					{'V'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-83.41 40.625 18.847)"
// 				id="text299"
// 			>
// 				<tspan x={0} y={0} id="tspan297">
// 					{'I'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-79.65 41.923 17.272)"
// 				id="text303"
// 			>
// 				<tspan x={0} y={0} id="tspan301">
// 					{'S'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-75.85 42.26 14.272)"
// 				id="text307"
// 			>
// 				<tspan x={0} y={0} id="tspan305">
// 					{'I'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-71.94 43.78 12.357)"
// 				id="text311"
// 			>
// 				<tspan x={0} y={0} id="tspan309">
// 					{'B'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-66.86 45.058 8.364)"
// 				id="text315"
// 			>
// 				<tspan x={0} y={0} id="tspan313">
// 					{'L'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-62.05 46.624 4.337)"
// 				id="text319"
// 			>
// 				<tspan x={0} y={0} id="tspan317">
// 					{'E'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-12.85 120.216 -195.096)"
// 				id="text323"
// 			>
// 				<tspan x={0} y={0} id="tspan321">
// 					{'D'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-8.6 164.567 -326.275)"
// 				id="text327"
// 			>
// 				<tspan x={0} y={0} id="tspan325">
// 					{'I'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(-3.74 341.737 -789.407)"
// 				id="text331"
// 			>
// 				<tspan x={0} y={0} id="tspan329">
// 					{'M'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(3.62 -291.81 919.912)"
// 				id="text335"
// 			>
// 				<tspan x={0} y={0} id="tspan333">
// 					{'M'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(9.77 -89.316 377.418)"
// 				id="text339"
// 			>
// 				<tspan x={0} y={0} id="tspan337">
// 					{'E'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(15.34 -45.637 256.461)"
// 				id="text343"
// 			>
// 				<tspan x={0} y={0} id="tspan341">
// 					{'D'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(75.81 16.728 86.41)"
// 				id="text347"
// 			>
// 				<tspan x={0} y={0} id="tspan345">
// 					{'B'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(81.19 17.909 83.165)"
// 				id="text351"
// 			>
// 				<tspan x={0} y={0} id="tspan349">
// 					{'R'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(84.95 18.127 81.676)"
// 				id="text355"
// 			>
// 				<tspan x={0} y={0} id="tspan353">
// 					{'I'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(88.92 19.447 79.003)"
// 				id="text359"
// 			>
// 				<tspan x={0} y={0} id="tspan357">
// 					{'G'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(94.8 20.565 76.151)"
// 				id="text363"
// 			>
// 				<tspan x={0} y={0} id="tspan361">
// 					{'H'}
// 				</tspan>
// 			</text>
// 			<text
// 				className="cls-6"
// 				transform="rotate(100.32 21.155 74.022)"
// 				id="text367"
// 			>
// 				<tspan x={0} y={0} id="tspan365">
// 					{'T'}
// 				</tspan>
// 			</text>
// 		</g>
// 	</g>
// 	<chakra.path
// 		id="bright"
// 		transition={arrowTransition}
// 		opacity={visibility === 'bright' ? 1 : 0}
// 		className="cls-13"
// 		transform="translate(0 -2.83)"
// 		d="m102.95 58.88 12.14 7.01V51.87z"
// 	/>
// 	<chakra.path
// 		transition={arrowTransition}
// 		opacity={visibility === 'visible' ? 1 : 0}
// 		id="dimmed"
// 		className="cls-13"
// 		transform="translate(0 -2.83)"
// 		d="m57.6 14.97 7.01-12.14H50.59z"
// 	/>
// 	<chakra.path
// 		transition={arrowTransition}
// 		id="not visible"
// 		opacity={visibility === 'not visible' ? 1 : 0}
// 		className="cls-13"
// 		transform="translate(0 -2.83)"
// 		d="M12.14 58.88 0 51.87v14.02z"
// 	/>
// </svg> )

export default VisibilityResults
